import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QuizService {

  // Quiz questions for the current module, will reload on each module
  moduleQuizQuestions = [];

  constructor(private http: HttpClient) { }

  // Get questions from database
  getModuleQuizzes(moduleID: string) {
    return this.http.post('api/v1/quizzes/getModuleQuizzes', {module: moduleID});
  }
}
